import { ComponentAPI } from '@philips-internal/oswald-ui-core';
import { TextProperties } from './text-types.js';
class TextAPI extends ComponentAPI {
    /**
     * Gets the alignment of the text.
     *
     * @returns the alignment of the text.
     */
    getAlignment() {
        return this.state.alignment ?? TextProperties.alignment.defaultValue;
    }
    /**
    * Sets the alignment of the text.
    *
    * @param alignment - The alignment of the text.
    */
    setAlignment(alignment) {
        this.setState({ alignment });
    }
    /**
     * Checks if the text is bold.
     *
     * @returns a boolean indicating if the text is bold.
     */
    getBold() {
        return Boolean(this.state.bold);
    }
    /**
     * Sets if the text should be bold.
     *
     * @param bold - If the text should be bold.
     */
    setBold(bold) {
        this.setState({ bold });
    }
    /**
     * Returns if the text translation is disabled.
     */
    isTranslationDisabled() {
        return Boolean(this.state.disableTranslation);
    }
    /**
    * Sets if the text translation should be disabled.
    *
    * @param disableTranslation - If the text translation should be disabled.
    */
    setDisableTranslation(disableTranslation) {
        this.setState({ disableTranslation });
    }
    /**
     * Returns if the text will generate ellipsis on overflow.
     */
    isEllipsis() {
        return Boolean(this.state.ellipsis);
    }
    /**
    * Sets if the text will generate ellipsis on overflow.
    *
    * @param ellipsis - If the text will generate ellipsis on overflow.
    */
    setEllipsis(ellipsis) {
        this.setState({ ellipsis });
    }
    /**
     * Gets the font family of the text.
     *
     * @returns the font family of the text.
     */
    getFamily() {
        return this.state.family ?? TextProperties.family.defaultValue;
    }
    /**
    * Sets the font family of the text.
    *
    * @param family - The font family of the text.
    */
    setFamily(family) {
        this.setState({ family });
    }
    /**
     * Gets the signal color of the text.
     *
     * @returns the signal color of the text.
     */
    getSignalColor() {
        return this.state.signalColor ?? TextProperties.signalColor.defaultValue;
    }
    /**
    * Sets the signal color of the text.
    *
    * @param signalColor - The signal color of the text.
    */
    setSignalColor(signalColor) {
        this.setState({ signalColor });
    }
    /**
     * Gets the signal shade of the text.
     *
     * @returns the signal shade of the text.
     */
    getSignalShade() {
        return this.state.signalShade ?? TextProperties.signalShade.defaultValue;
    }
    /**
    * Sets the signal shade of the text.
    *
    * @param signalShade - The signal shade of the text.
    */
    setSignalShade(signalShade) {
        this.setState({ signalShade });
    }
    /**
     * Gets the font size of the text.
     *
     * @returns the font size of the text.
     */
    getSize() {
        return this.state.size ?? TextProperties.size.defaultValue;
    }
    /**
    * Sets the font size of the text.
    *
    * @param size - The font size of the text.
    */
    setSize(size) {
        this.setState({ size });
    }
    /**
     * Gets the type of the text.
     *
     * @returns the type of the text.
     */
    getType() {
        return this.state.type ?? TextProperties.type.defaultValue;
    }
    /**
    * Sets the type of the text.
    *
    * @param type - The type of the text.
    */
    setType(type) {
        this.setState({ type });
    }
    /**
     * Checks if the text is uppercase.
     *
     * @returns a boolean indicating if the text is uppercase.
     */
    getUppercase() {
        return Boolean(this.state.uppercase);
    }
    /**
     * Sets if the text should be uppercase.
     *
     * @param uppercase - If the text should be uppercase.
     */
    setUppercase(uppercase) {
        this.setState({ uppercase });
    }
    /**
     * Gets the value of the text.
     *
     * @returns the value of the text.
     */
    getValue() {
        return this.state.value ?? '';
    }
    /**
    * Sets the value of the text.
    *
    * @param value - The value of the text.
    */
    setValue(value) {
        this.setState({ value });
    }
    /**
     * Checks if the text is being struckthrough.
     *
     * @returns a boolean indicating if the text is being struckthrough.
     */
    isStrikethrough() {
        return Boolean(this.state.strikethrough);
    }
    /**
     * Sets if the text should be struckthrough.
     *
     * @param strikethrough - If the text should be struckthrough.
     */
    setStrikethrough(strikethrough) {
        this.setState({ strikethrough });
    }
    /**
     * Gets the configured sensitiveness for the text.
     *
     * @returns the configured sensitiveness for the text.
     */
    getSensitiveData() {
        return this.state.sensitiveData ?? TextProperties.sensitiveData.defaultValue;
    }
    /**
     * Sets if the text content should be hidden.
     *
     * @param sensitiveData - How sensitive the data is.
     */
    setSensitiveData(sensitiveData) {
        this.setState({ sensitiveData });
    }
}
export { TextAPI, };
//# sourceMappingURL=text-api.js.map